import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Counterparty() {
  const [searchType, setSearchType] = useState('inn');
  const [searchValue, setSearchValue] = useState('');
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState(() => {
    const saved = localStorage.getItem('khepri_counterparty_history');
    return saved ? JSON.parse(saved) : [];
  });
  const [favorites, setFavorites] = useState(() => {
    const saved = localStorage.getItem('khepri_counterparty_favorites');
    return saved ? JSON.parse(saved) : [];
  });

  const check = async (e) => {
    e.preventDefault();
    if (!searchValue.trim()) return;

    let data;
    if (searchType === 'inn') {
      const res = await fetch(API + '/tax/check_counterparty?inn=' + searchValue);
      data = await res.json();
    } else {
      // Поиск по названию — демо-данные
      data = {
        inn: 'ИНН не найден',
        name: searchValue,
        status: Math.random() > 0.5 ? 'ok' : 'high',
        risks: [
          { severity: 'low', description: 'Компания найдена по названию (демо-режим)' },
        ],
      };
    }

    setResult(data);

    const newRecord = {
      inn: data.inn || searchValue,
      name: data.name || '',
      status: data.status,
      date: new Date().toLocaleString('ru-RU'),
    };
    const updated = [newRecord, ...history.filter(h => h.inn !== newRecord.inn)].slice(0, 10);
    setHistory(updated);
    localStorage.setItem('khepri_counterparty_history', JSON.stringify(updated));
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem('khepri_counterparty_history');
  };

  const toggleFavorite = (id) => {
    setFavorites(prev => {
      const exists = prev.includes(id);
      const updated = exists ? prev.filter(f => f !== id) : [...prev, id];
      localStorage.setItem('khepri_counterparty_favorites', JSON.stringify(updated));
      return updated;
    });
  };

  const isFavorite = (id) => favorites.includes(id);

  const getStatusColor = (status) => {
    if (status === 'critical') return '#EF4444';
    if (status === 'high') return '#F59E0B';
    return '#10B981';
  };

  const getStatusText = (status) => {
    if (status === 'critical') return 'Критический';
    if (status === 'high') return 'Высокий';
    return 'Нормальный';
  };

  return (
    <div>
      <h2>Проверка контрагента</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 12 }}>
        Проверьте контрагента по ИНН или названию компании
      </p>

      {/* Переключатель типа поиска */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <button
          type="button"
          onClick={() => { setSearchType('inn'); setSearchValue(''); setResult(null); }}
          style={{
            padding: '8px 16px',
            background: searchType === 'inn' ? '#6366F1' : '#1E293B',
            color: searchType === 'inn' ? '#fff' : '#94A3B8',
            border: '1px solid #334155',
            borderRadius: 20,
            cursor: 'pointer',
            fontSize: 13,
          }}
        >
          По ИНН
        </button>
        <button
          type="button"
          onClick={() => { setSearchType('name'); setSearchValue(''); setResult(null); }}
          style={{
            padding: '8px 16px',
            background: searchType === 'name' ? '#6366F1' : '#1E293B',
            color: searchType === 'name' ? '#fff' : '#94A3B8',
            border: '1px solid #334155',
            borderRadius: 20,
            cursor: 'pointer',
            fontSize: 13,
          }}
        >
          По названию
        </button>
      </div>

      <form onSubmit={check} style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <input
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          placeholder={searchType === 'inn' ? 'ИНН (10 цифр)' : 'Название компании'}
          style={{ flex: 1, padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}
        />
        <button type="submit" style={{ padding: '10px 20px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Проверить</button>
      </form>

      {result && (
        <div style={{ marginTop: 16, padding: 16, background: '#1E293B', borderRadius: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
            <div>
              {result.inn && result.inn !== 'ИНН не найден' && <p>ИНН: {result.inn}</p>}
              {result.name && <p>Название: {result.name}</p>}
              <p>Статус: <span style={{ color: getStatusColor(result.status), fontWeight: 600 }}>{getStatusText(result.status)}</span></p>
            </div>
            <button
              onClick={() => toggleFavorite(result.inn || result.name)}
              style={{
                padding: '8px 16px',
                background: isFavorite(result.inn || result.name) ? '#F59E0B' : '#334155',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 13,
              }}
            >
              {isFavorite(result.inn || result.name) ? '★ В избранном' : '☆ В избранное'}
            </button>
          </div>
          {(result.risks || []).map((r, i) => <p key={i} style={{ color: '#F59E0B' }}>[{r.severity}] {r.description}</p>)}
        </div>
      )}

      {favorites.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h3>⭐ Избранные контрагенты</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
            {favorites.map((fav, i) => (
              <div key={i} style={{ padding: '8px 16px', background: '#1E293B', border: '1px solid #F59E0B', borderRadius: 20, cursor: 'pointer' }} onClick={() => setSearchValue(fav)}>
                <span style={{ color: '#F59E0B', marginRight: 6 }}>★</span>
                <span style={{ fontSize: 13 }}>{fav}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {history.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <h3>📋 История проверок</h3>
            <button onClick={clearHistory} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 12, textDecoration: 'underline' }}>
              Очистить
            </button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>ИНН / Название</th>
                <th style={{ padding: 8 }}>Статус</th>
                <th style={{ padding: 8 }}>Дата проверки</th>
                <th style={{ padding: 8 }}>Избранное</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #334155', cursor: 'pointer' }} onClick={() => setSearchValue(h.inn)}>
                  <td style={{ padding: 8 }}>{h.name || h.inn}</td>
                  <td style={{ padding: 8 }}>
                    <span style={{ color: getStatusColor(h.status), fontWeight: 600 }}>{getStatusText(h.status)}</span>
                  </td>
                  <td style={{ padding: 8, color: '#94A3B8' }}>{h.date}</td>
                  <td style={{ padding: 8 }}>
                    <span style={{ color: isFavorite(h.inn || h.name) ? '#F59E0B' : '#94A3B8' }}>{isFavorite(h.inn || h.name) ? '★' : '☆'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Counterparty;